// src/user/pages/FillProfile.js
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

export default function FillProfile() {
  const navigate = useNavigate();
  const userId = sessionStorage.getItem("userId");

  const [name, setName] = useState("");
  const [country, setCountry] = useState("");

  const handleSubmit = async () => {
    if (!name || !country) {
      toast.error("Please complete your profile");
      return;
    }

    try {
      const res = await axios.post("/updateProfile", {
        userId,
        name,
        country,
      });

      if (res.data?.status) {
        navigate("/");
      } else {
        toast.error(res.data?.message);
      }
    } catch {
      toast.error("Profile update failed");
    }
  };

  return (
    <div>
      <h2>Complete Your Profile</h2>

      <input
        placeholder="Full Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />

      <input
        placeholder="Country"
        value={country}
        onChange={(e) => setCountry(e.target.value)}
      />

      <button onClick={handleSubmit}>Continue</button>
    </div>
  );
}
